angular.module('controllers').controller('kitchenController', ['$scope', '$rootScope', '$controller', 'Crud', '$mdDialog', '$filter', '$http', '$route', '$routeParams', '$location', '$timeout', '$interval',
	function ($scope, $rootScope, $controller, Crud, $mdDialog, $filter, $http, $route, $routeParams, $location, $timeout, $interval) {
		$rootScope.path = '/kitchen';
		$scope.path = $rootScope.path;
		$rootScope.modelName = 'kitchen';
		$scope.pathTemplate = 'food/kitchens';
		$scope.title = 'Bucatarii';

		angular.extend(this, $controller('crudController', {$scope: $scope}));

		$scope.sortType = 'street_no';
		$scope.defaultItem = 10;
		$rootScope.typeId = 'id';
		$scope.classAction = 'td-big';
		$scope.columns = {
			//'id':{'label':'Id', 'filter':1, 'filterType':'input'},
			'kitchen_name':{'label':'Denumire bucatarie', 'filter':1, 'filterType':'input'},
			'username':{'label':'Utilizator', 'filter':1, 'filterType':'input'},
			'shipping_methods':{'label':'Livrare', 'filter':1, 'filterType':'input'},
			'food_categories':{'label':'Meniuri', 'filter':1, 'filterType':'input'},
      'locality_name':{'label':'Sediu (localitate)', 'filter':1, 'filterType':'input'},
      'section_name':{'label':'Sediu (cartier)', 'filter':1, 'filterType':'input'},
			//'localities':{'label':'Localitati / Cartiere', 'filter':1, 'filterType':'input'},
			'status':{'label':'Status', 'filter':1, 'filterType':'select'}
		};

		$scope.columns.status.options = [
			{'id':'', 'value' : ''},
			{'id':1, 'value' : 'true'},
			{'id':0, 'value' : 'false'}
		];

		$scope.additionals['status_string'] = JSON.stringify($scope.columns.status.options);

		$scope.search.order = 'asc';
		$scope.additionals['content_type'] = 'form-urlencoded';
    $scope.additionals['columnDisplay'] = 'kitchen_name';
		$scope.additionals['jsonPath'] = '/json';

    $scope.additionals['kitchenColors'] = [
        {'id': 1, 'value': 'Galben', 'color': 'rgba(242, 237, 86, 0.9)', 'color-even': 'rgba(242, 237, 86, 0.7)'},//yellow
        {'id': 2, 'value': 'Rosu', 'color': 'rgba(193, 32, 38, 0.7)', 'color-even': 'rgba(193, 32, 38, 0.5)'},//red
        {'id': 3, 'value': 'Maro', 'color': 'rgba(222, 96, 27, 0.5)', 'color-even': 'rgba(222, 96, 27, 0.3)'},//brown
        {'id': 4, 'value': 'Verde', 'color': 'rgba(169, 215, 65, 0.9)', 'color-even': 'rgba(169, 215, 65, 0.7)'},//green
        {'id': 5, 'value': 'Albastru', 'color': 'rgba(0, 51, 153, 0.4)', 'color-even': 'rgba(0, 51, 153, 0.2)'},//blue
        {'id': 6, 'value': 'Negru', 'color': 'rgba(90, 87, 87, 0.8)', 'color-even': 'rgba(90, 87, 87, 0.6)'}//black
    ];

		/* get dependent fields */
		$scope.getDependedFields = function () {
			Crud.getDependedFields($scope.path)
				.success(function (data) {
					$scope.additionals['users'] = data.users;
					$scope.additionals['shipping_methods'] = data.shipping_methods;
					$scope.additionals['food_categories'] = data.food_categories;
					$scope.additionals['localities'] = data.localities;
          $scope.additionals['restaurants'] = data.restaurants;
				});

        Crud.getDependedFields('menu')
          .success(function (data) {
              $scope.getCategoryHierarchy = $scope.additionals['makeDropDown'](data.parents, 'menu_title');
              $scope.additionals['parents'] = $scope.getCategoryHierarchy;
          });
		}

		$scope.additionals['searchTerm'];
		$scope.additionals['clearSearchTerm'] = function() {
		$scope.additionals['searchTerm'] = '';
		};
		$scope.additionals['onSearchChange'] = function(ev) {
			ev.stopPropagation();
		};

    $scope.additionals['clearColorPicker'] = function () {
        $scope.modelData.kitchen_color = '';
    }

		$scope.additionals['getCounties'] = function () {
			Crud.get($scope.additionals['jsonPath'] + '/counties.json')
				.success(function (data) {
					$scope.additionals['counties'] = data;
				});
		}
		$scope.additionals['getCounties']();
		if (angular.isUndefined($scope.search.county_name)) {
			$scope.search.county_name = 'Cluj';
		}

	  /* autocomplete */
	  function createFilterForLocality(query) {
	      var capitalizeQuery = $scope.formatText(query);
	      return function filterFn(item) {
	          return item.locality_name.indexOf(capitalizeQuery) >= 0;
	      };
	  }
	  function createFilterForSection(query) {
	      var capitalizeQuery = $scope.formatText(query);
	      return function filterFn(item) {
	          return item.section_name.indexOf(capitalizeQuery) >= 0;
	      };
	  }
	  $scope.additionals['getLocalities'] = function(model, index) {
	      model.locality_id = 0;
	      Crud.get($scope.path + '/getLocalities?county_name=Cluj')
	          .success(function (dataLoc) {

	              if(dataLoc.localities.length <= 0) {
	                  Crud.get($scope.additionals['jsonPath'] + '/localities.json')
	                      .success(function (data) {
	                          if (!angular.isUndefined(index)) {
	                              $scope.additionals['localitiesHead' + index] = {};
	                          } else {
	                              $scope.additionals['localitiesHead'] = {};
	                          }

	                          /* autocomplete */
	                          function querySearch(query) {
	                              if (!angular.isUndefined(index)) {
	                                  var results = query ? $scope.additionals['localitiesHead' + index].filter(createFilterForLocality(query)) : [];
	                              } else {
	                                  if (!angular.isUndefined($scope.additionals['localitiesHead'])) {
	                                      var results = query ? $scope.additionals['localitiesHead'].filter(createFilterForLocality(query)) : [];
	                                  }
	                              }
	                              return results;
	                          }
	                          $scope.additionals['searchLocality'] = querySearch;
	                          $scope.additionals['errors'] = {};
	                          /* end autocomplete */

	                      });
	              } else {
	                  if (!angular.isUndefined(index)) {
	                      $scope.additionals['localitiesHead' + index] = dataLoc['localities'];
	                  } else {
	                      $scope.additionals['localitiesHead'] = dataLoc['localities'];
	                  }
	                  /* autocomplete */
	                  function querySearch(query) {
	                      if (!angular.isUndefined(index)) {
	                          var results = query ? $scope.additionals['localitiesHead' + index].filter(createFilterForLocality(query)) : [];
	                      } else {
	                          if (!angular.isUndefined($scope.additionals['localitiesHead'])) {
	                              var results = query ? $scope.additionals['localitiesHead'].filter(createFilterForLocality(query)) : [];
	                          }
	                      }
	                      return results;
	                  }
	                  $scope.additionals['searchLocality'] = querySearch;
	                  $scope.additionals['errors'] = {};
	                  /* end autocomplete */
	              }

	          });
        }
        $scope.additionals['getSections'] = function(model, index) {
            Crud.get($scope.path + '/getSections?county_name=Cluj&locality_name='+model.locality_name)
                .success(function (data) {
                    if (!angular.isUndefined(index)) {
                        $scope.additionals['sectionsHead' + index] = data['sections'];
                    } else {
                        $scope.additionals['sectionsHead'] = data['sections'];
                    }
                    /* autocomplete */
                    function querySearch(query) {
                        if (!angular.isUndefined(index)) {
                            var results = query ? $scope.additionals['sectionsHead' + index].filter(createFilterForSection(query)) : [];
                        } else {
                            if (!angular.isUndefined($scope.additionals['sectionsHead'])) {
                                var results = query ? $scope.additionals['sectionsHead'].filter(createFilterForSection(query)) : [];
                            }
                        }
                        return results;
                    }
                    $scope.additionals['searchSection'] = querySearch;
                    $scope.additionals['errors'] = {};
                    /* end autocomplete */
                });
        }

        /* change field */
        $scope.additionals['changeField']= function(model, prop, key) {
            if (angular.isUndefined(key)) {
                $scope.additionals['getLocalitiesFields']();
            }
        }

        $scope.additionals['selectField']= function(model, prop, key) {
            if (angular.isUndefined(key)) {
                $scope.additionals['getLocalitiesFields']();
            }
        }

        /* close field */
        $scope.additionals['closeField'] = function (paramName, model, key) {
            if (!angular.isUndefined(key)) {
                model[key][paramName] = '';
            } else {
                model[paramName] = '';
            }
        }

        $scope.additionals['function']= function(ev, model) {
            $scope.additionals['selectedItemLocality'] = '';
            $scope.additionals['selectedItemSection'] = '';

            if(!angular.isUndefined(model['allow_print_bc'])) {
                if (model['allow_print_bc'] == 1) {
                    model['allow_print_bc'] = true;
                }
                if (model['allow_print_bc'] == 0) {
                    model['allow_print_bc'] = false;
                }
            }
            if(!angular.isUndefined(model['allow_print_np'])) {
                if (model['allow_print_np'] == 1) {
                    model['allow_print_np'] = true;
                }
                if (model['allow_print_np'] == 0) {
                    model['allow_print_np'] = false;
                }
            }
            if(!angular.isUndefined(model['allow_print_bf'])) {
                if (model['allow_print_bf'] == 1) {
                    model['allow_print_bf'] = true;
                }
                if (model['allow_print_bf'] == 0) {
                    model['allow_print_bf'] = false;
                }
            }
            if(!angular.isUndefined(model['allow_detail'])) {
                if (model['allow_detail'] == 1) {
                    model['allow_detail'] = true;
                }
                if (model['allow_detail'] == 0) {
                    model['allow_detail'] = false;
                }
            }

            if(!angular.isUndefined(model['allow_history'])) {
                if (model['allow_history'] == 1) {
                    model['allow_history'] = true;
                }
                if (model['allow_history'] == 0) {
                    model['allow_history'] = false;
                }
            }

            if(!angular.isUndefined(model['allow_move'])) {
                if (model['allow_move'] == 1) {
                    model['allow_move'] = true;
                }
                if (model['allow_move'] == 0) {
                    model['allow_move'] = false;
                }
            }

            if(!angular.isUndefined(model['kitchen_center'])) {
                if (model['kitchen_center'] == 1) {
                    model['kitchen_center'] = true;
                }
                if (model['kitchen_center'] == 0) {
                    model['kitchen_center'] = false;
                }
            }

        if(!angular.isUndefined(model['kitchen_single'])) {
                if (model['kitchen_single'] == 1) {
                    model['kitchen_single'] = true;
                }
                if (model['kitchen_single'] == 0) {
                    model['kitchen_single'] = false;
                }
            }

            if($scope.action == 'publish') {
                model.menu_title = model.kitchen_name;
            }

			if($scope.action == 'store') {
				if (angular.isUndefined(model.county_name)) {
					model.county_name = 'Cluj';
				}
        $scope.additionals['getLocalitiesFields']();
			}

      if($scope.action == 'update') {
          $scope.additionals['getLocalitiesFields'](model.id);
      }

			if($scope.action != 'updatemultiple') {
				model.food_category_id = [];
				angular.forEach(model.food_categories, function (item, index) {
					model.food_category_id[index] = item.id;
				});

				model.shipping_method_id = [];
				angular.forEach(model.shipping_methods, function (item, index) {
					model.shipping_method_id[index] = item.id;
				});
			} else {
        $scope.additionals['selectedItemLocality'] = [];
        $scope.additionals['selectedItemSection'] = [];

				angular.forEach(model, function (item, index) {
						item.food_category_id = [];
						angular.forEach(item.food_categories, function (itemFoodCategory, indexFoodCategory) {
							item.food_category_id[indexFoodCategory] = itemFoodCategory.id;
	          });

						item.shipping_method_id = [];
						angular.forEach(item.shipping_methods, function (itemShippingMethod, indexShippingMethod) {
							item.shipping_method_id[indexShippingMethod] = itemShippingMethod.id;
	          });

            if(!angular.isUndefined(item['allow_print_bc'])) {
                if (item['allow_print_bc'] == 1) {
                    item['allow_print_bc'] = true;
                }
                if (item['allow_print_bc'] == 0) {
                    item['allow_print_bc'] = false;
                }
            }
            if(!angular.isUndefined(item['allow_print_np'])) {
                if (item['allow_print_np'] == 1) {
                    item['allow_print_np'] = true;
                }
                if (item['allow_print_np'] == 0) {
                    item['allow_print_np'] = false;
                }
            }
            if(!angular.isUndefined(item['allow_print_bf'])) {
                if (item['allow_print_bf'] == 1) {
                    item['allow_print_bf'] = true;
                }
                if (item['allow_print_bf'] == 0) {
                    item['allow_print_bf'] = false;
                }
            }
            if(!angular.isUndefined(item['allow_detail'])) {
                if (item['allow_detail'] == 1) {
                    item['allow_detail'] = true;
                }
                if (item['allow_detail'] == 0) {
                    item['allow_detail'] = false;
                }
            }
            if(!angular.isUndefined(item['allow_history'])) {
                if (item['allow_history'] == 1) {
                    item['allow_history'] = true;
                }
                if (item['allow_history'] == 0) {
                    item['allow_history'] = false;
                }
            }
            if(!angular.isUndefined(item['allow_move'])) {
                if (item['allow_move'] == 1) {
                    item['allow_move'] = true;
                }
                if (item['allow_move'] == 0) {
                    item['allow_move'] = false;
                }
            }
            if(!angular.isUndefined(item['kitchen_center'])) {
                if (item['kitchen_center'] == 1) {
                    item['kitchen_center'] = true;
                }
                if (item['kitchen_center'] == 0) {
                    item['kitchen_center'] = false;
                }
            }
            if(!angular.isUndefined(item['kitchen_single'])) {
                if (item['kitchen_single'] == 1) {
                    item['kitchen_single'] = true;
                }
                if (item['kitchen_single'] == 0) {
                    item['kitchen_single'] = false;
                }
            }

				});
			}
		}

    $scope.additionals['internFunction'] = function(ev, model) {
        if($scope.action == 'updatemultiple') {

            angular.forEach(model, function (item, index) {
                if(index != 'route') {
                    if (!angular.isUndefined($scope.additionals['localitiesHead'+index])) {
                        if (!angular.isUndefined($scope.additionals['localitiesHead' + index][0]['id'])) {
                            var checkLocalityId = $scope.additionals['checkField']($scope.additionals['localitiesHead'+index], 'id', 'locality_name', item['locality_name']);
                            if (checkLocalityId) {
                                item.locality_id = checkLocalityId;
                            } else {
                                item.locality_id = 0;
                            }
                        } else {
                            item.locality_id = 'js';
                        }
                    }
                    var checkLocalityName = $scope.additionals['checkField']($scope.additionals['localitiesHead'+index], 'locality_name', 'locality_name', item['locality_name']);
                    if (checkLocalityName) {
                        item.locality_name = checkLocalityName;
                    } else {
                        if(item.locality_id == 'js') {
                            item.locality_name = '';
                        }
                    }
                    if (!angular.isUndefined($scope.additionals['sectionsHead'+index])) {
                        var checkSectionId = $scope.additionals['checkField']($scope.additionals['sectionsHead'+index], 'id', 'section_name', item['section_name']);
                        if (checkSectionId) {
                            item.section_id = checkSectionId;
                        } else {
                            item.section_id = 0;
                        }
                    }
                    var checkSectionName = $scope.additionals['checkField']($scope.additionals['sectionsHead'+index], 'section_name', 'section_name', item['section_name']);
                    if (checkSectionName) {
                        item.section_name = checkSectionName;
                    }

                }
            });
        } else {
            if (model['locality_name'] != '' && $scope.additionals['localitiesHead']) {
                if (!angular.isUndefined($scope.additionals['localitiesHead'][0]['id'])) {
                    var checkLocalityId = $scope.additionals['checkField']($scope.additionals['localitiesHead'], 'id', 'locality_name', model['locality_name']);
                    if (checkLocalityId) {
                        model.locality_id = checkLocalityId;
                    } else {
                        model.locality_id = 0;
                    }
                } else {
                    model.locality_id = 'js';
                }

                var checkLocalityName = $scope.additionals['checkField']($scope.additionals['localitiesHead'], 'locality_name', 'locality_name', model['locality_name']);
                if (checkLocalityName) {
                    model.locality_name = checkLocalityName;
                } else {
                    if(model.locality_id == 'js') {
                        model.locality_name = '';
                    }
                }
            }
            if (model['section_name'] != '' && $scope.additionals['sectionsHead']) {
                var checkSectionId = $scope.additionals['checkField']($scope.additionals['sectionsHead'], 'id', 'section_name', model['section_name']);
                if (checkSectionId) {
                    model.section_id = checkSectionId;
                } else {
                    model.section_id = 0;
                }
                var checkSectionName = $scope.additionals['checkField']($scope.additionals['sectionsHead'], 'section_name', 'section_name', model['section_name']);
                if (checkSectionName) {
                    model.section_name = checkSectionName;
                }
            }

        }
    }

    $scope.additionals['getLocalitiesFields'] = function (kitchenId) {
         var extens = '';
        if(!angular.isUndefined($scope.modelData.locality_name) && $scope.modelData.locality_name != '') {
            extens = '/?locality_name=' + $scope.modelData.locality_name;
            if (!angular.isUndefined($scope.modelData.section_name) && $scope.modelData.section_name != '') {
                extens = extens + '&section_name=' + $scope.modelData.section_name;
            }
        }
        if (!angular.isUndefined(kitchenId)) {
            var pathK = $scope.path+'/localitiesFields/?kitchenId='+kitchenId;
        } else {
            var pathK = $scope.path+'/localitiesFields'+extens;
        }
        Crud.get(pathK)
        .success(function (data) {
            $scope.additionals['localities'] = data.localities;
        });

    }

		/*assign localities to kitchens*/
    $scope.additionals['getKitchens'] = function () {
        Crud.get($scope.path+'/kitchens')
            .success(function (data) {
                $scope.additionals['kitchens'] = data.kitchens;
            });
    }

    $scope.additionals['getAssignedFields'] = function (kitchenId, kitchenValue) {

    angular.forEach($scope.additionals['kitchens'], function (item, key) {
        if( item['id'] != kitchenId) {
                $scope.modelData['kitchens'][item['id']] = false;
            }
        });

        $scope.additionals['currentKitchen'] = kitchenId;

        Crud.get($scope.path+'/assignedFields/?kitchenId='+kitchenId)
            .success(function (data) {
                $scope.additionals['localities_updated'] = data.localities_updated;

                $scope.modelData['locs'] = data.result.locs;
                $scope.modelData['secs'] = data.result.secs;

            });
    }

    /* assign model */
    $scope.assignModel = function (ev, path) {

        $scope.additionals['getKitchens']();

        if($scope.mode_action == 'page') {
            $scope.controlSH = true;
            $scope.action = 'assign';
            $scope.errors = {};
            $scope.additionals['invalid'] = '';
            angular.element(document.querySelector('.fill-height')).animate({ scrollTop: 250 }, "slow");

            $scope.modelData = {};
            $scope.additionals['localities_updated'] = [];

            $scope.cancel = function () {
                $scope.modelData = {};
                $scope.errors = {};
                $scope.controlSH = false;
                $scope.additionals['localities_updated'] = [];
            };

            $scope.assign = function (kitchenId, localityId, sectionId) {

                if($scope.modelData['kitchens'][kitchenId] == true) {
                    $scope.isLoading = true;
                    var post = {};
                    post['route'] = 'assign';
                    post['kitchen'] = {'kitchenId':kitchenId, 'kitchenValue':$scope.modelData['kitchens'][kitchenId]};

                    if (!angular.isUndefined($scope.modelData['locs']) && $scope.modelData['locs'].length > 0) {
                        post['locality'] = {
                            'localityId': localityId,
                            'localityValue': $scope.modelData['locs'][kitchenId][localityId]
                        }
                    } else {
                        post['locality'] = {
                            'localityId': localityId}
                    }
                    if (!angular.isUndefined(sectionId) && !angular.isUndefined($scope.modelData['secs'])) {
                        post['section'] = {
                            'sectionId': sectionId,
                            'sectionValue': $scope.modelData['secs'][kitchenId][localityId][sectionId]
                        };
                    }

                    Crud.post($scope.additionals['content_type'], post, path + '/assign')
                        .success(function (data) {
                            if (!angular.isUndefined(data.invalid)) {
                                $scope.additionals['invalid'] = data.invalid;
                            } else {
                                if (!angular.isUndefined(data.currentModel)) {
                                    if (!angular.isUndefined($scope.models)) {
                                        $scope.getElement($scope.models, data.currentModel);
                                    }
                                }
                            }
                            // $scope.modelData = {};
                            $scope.errors = {};
                            $scope.isLoading = false;
                            // $scope.controlSH = false;
                        })
                        .error(function (data) {
                            $scope.isLoading = false;
                            $scope.errors = data.errors;
                        });
                }
            };
        }
        if($scope.mode_action == 'dialog') {
            $scope.additionals['invalid'] = '';
            $scope.errors = {};
            $scope.action = 'assign';

            $scope.modelData = {};
            $scope.additionals['localities_updated'] = [];

            $mdDialog.show({
                controller: DialogController,
                templateUrl: 'assignDialog.tmpl.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {
                    pathTemplate: $scope.pathTemplate,
                    model: $scope.modelData,
                    selected: $scope.selected,
                    additionals: $scope.additionals,
                    action: $scope.action
                }
            }).then(function () {
                if (angular.isUndefined($scope.additionals['invalid']) || $scope.additionals['invalid'] == '') {
                    if (!angular.isUndefined($scope.additionals['dataCurrentModel'])) {
                        if (!angular.isUndefined($scope.models) && !angular.isUndefined($scope.models)) {
                            $scope.getElement($scope.models, $scope.additionals['dataCurrentModel']);
                        }
                    }

                }
            });
            DialogController.$inject = ['$scope', '$mdDialog', 'pathTemplate', 'model', 'selected', 'additionals', 'action'];
            function DialogController($scope, $mdDialog, pathTemplate, model, selected, additionals, action) {
                $scope.pathTemplate = pathTemplate;
                $scope.modelData = model;
                $scope.additionals = additionals;
                $scope.selected = selected;
                $scope.action = action;

                $scope.cancel = function () {
                    $mdDialog.cancel();
                };

                $scope.assign = function (kitchenId, localityId, sectionId) {

                    if($scope.modelData['kitchens'][kitchenId] == true) {
                        $scope.isLoading = true;
                        var post = {};
                        post['route'] = 'assign';
                        post['kitchen'] = {
                            'kitchenId': kitchenId,
                            'kitchenValue': $scope.modelData['kitchens'][kitchenId]
                        };
                        if (!angular.isUndefined($scope.modelData['locs']) && $scope.modelData['locs'].length > 0) {
                            post['locality'] = {
                                'localityId': localityId,
                                'localityValue': $scope.modelData['locs'][kitchenId][localityId]
                            }
                        } else {
                            post['locality'] = {
                                'localityId': localityId
                            }
                        }
                        if (!angular.isUndefined(sectionId) && !angular.isUndefined($scope.modelData['secs'])) {
                            post['section'] = {
                                'sectionId': sectionId,
                                'sectionValue': $scope.modelData['secs'][kitchenId][localityId][sectionId]
                            };
                        }

                        Crud.post($scope.additionals['content_type'], post, path + '/assign')
                            .success(function (data) {
                                if (!angular.isUndefined(data.invalid)) {
                                    $scope.additionals['invalid'] = data.invalid;
                                } else {

                                    /*if (!angular.isUndefined($scope.selected[model[$rootScope.typeId]])) {
                                     $scope.selected[model[$rootScope.typeId]] = model;
                                     }*/
                                    if (!angular.isUndefined(data.currentModel)) {
                                        $scope.additionals['dataCurrentModel'] = data.currentModel;
                                    }
                                }
                                $scope.isLoading = false;
                                $mdDialog.hide();
                            })
                            .error(function (data) {
                                $scope.isLoading = false;
                                $scope.errors = data.errors;
                            });
                    }
                };
            }
        }

    };

    $scope.additionals['changeCenter'] = function (model) {
              if(model['kitchen_center'] == true){
                    model['kitchen_single'] = false;
            }
    }

    $scope.additionals['changeSingle'] = function (model) {
            if(model['kitchen_single'] == true){
                    model['kitchen_center'] = false;
            }
    }

	}]
);
